import {Component, Inject, Input, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";

@Component({
   selector: 'app-dialog-error',
   templateUrl: './dialog-error.component.html',
   styleUrls: ['./dialog-error.component.scss']
})
export class DialogErrorComponent implements OnInit {

   title = "errore";
   html = "Impossibile completare l'operazione";

   constructor(@Inject(MAT_DIALOG_DATA) public data: {title:string, html:string}) {
      this.title = data.title || "Errore"
      this.html = data.html || "Impossibile completare l'operazione"
   }

   ngOnInit(): void {}

}
